module.exports = __webpack_public_path__ + "static/media/rotate.cc536a76.svg";